@if(item){
<div class="flex space-x-4 items-center py-5 w-full">
  <!-- Company Logo -->
  <div class="w-16 h-16 flex-shrink-0">
    <a [href]="'/company/' + item?.tenantId">
      <img
        [src]="item?.photoUrl || 'company_logo.svg'"
        alt="Company Logo"
        class="size-16 rounded-lg object-cover border border-gray-200"
      />
    </a>
  </div>

  <!-- Company Info -->
  <div class="flex-1 min-w-0">
    <a
      [href]="'/company/' + item?.tenantId"
      class="hover:underline hover:underline-offset-2"
    >
      <h2 class="text-base font-semibold">
        {{ item?.name || "Company" }}
      </h2>
    </a>

    <!-- Company Overview -->
    <p class="text-sm text-gray-800 truncate max-w-4xl">
      {{ formatString(item?.companyoverview || "No description available.") }}
    </p>

    <!-- Company Location & Size -->
    <div
      class="flex flex-col sm:flex-row sm:space-x-2 items-start sm:items-center text-sm text-gray-500"
    >
      <p *ngIf="item?.state || item?.country || item?.city">
        {{ item?.city && item?.city + "," }}
        {{ item?.state && item?.state + "," }}
        {{ item?.country | titlecase }}
      </p>
      <span *ngIf="item?.state || item?.country" class="hidden sm:inline"
        >&bull;</span
      >
      <p *ngIf="item?.companysize">{{ item?.companysize }}</p>
    </div>
  </div>
</div>

}
